import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';
import './app/styles/index.css';

if (import.meta.env.DEV) {
  void import('./core/catalog/catalogHealth').then((m) => {
    (
      window as unknown as { __catalogHealth?: typeof m.getCatalogHealthSnapshot }
    ).__catalogHealth = m.getCatalogHealthSnapshot;
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

